// HKDSE 中文科十二篇範文數據結構
export const hkdseTexts = {
  // A. 議論散文
  A: {
    category: '議論散文',
    description: '以論證手法為主，闡述道理和觀點',
    texts: {
      A1: {
        id: 'hkdse-a1-mengzi-fish',
        title: '孟子《魚我所欲也》',
        author: '孟子',
        dynasty: '戰國',
        category: '議論散文',
        mainTheme: '孟子透過以魚和熊掌分別比喻生存與道義，論證道義的價值會比生存更高，所以人會有捨生取義的行為；再指出這個捨生取義之心是每個人都會有的。再以一般人失去本心的原因，指出雖然這個本心是每個人都會有的，但是唯有賢者才不會失去，藉此勸勉人應該明辨義利，保持善良的本心，發揚義的善端。',
        examFocus: {
          argumentationMethods: ['比喻論證', '對比論證'],
          writingTechniques: ['正反立論'],
          rhetoricalDevices: ['比喻', '排比', '設問']
        },
        keyPoints: [
          '捨生取義的道德觀念',
          '本心不可失的重要性',
          '義利之辨的哲學思考',
          '比喻論證的運用技巧'
        ],
        difficulty: 'intermediate',
        studyTime: 45 // minutes
      },
      A2: {
        id: 'hkdse-a2-xunzi-learning',
        title: '荀子《勸學》（節錄）',
        author: '荀子',
        dynasty: '戰國',
        category: '議論散文',
        mainTheme: '作者提出了本文的主論點為學習是不可以停止的，然後從學習的意義、作用以及態度，鼓勵人學習，並且不可以鬆懈。指出後天學習是能夠改變人的本質的，再強調學習若能夠專心致志，不斷積累，就能夠突破自己的限制，否則便會一事無成。',
        examFocus: {
          argumentationMethods: ['比喻論證', '對比論證'],
          writingTechniques: ['層層遞進', '正面論證'],
          rhetoricalDevices: ['對比', '比喻', '排比', '對偶', '借代']
        },
        keyPoints: [
          '學不可以已的主論點',
          '學習改變人性的作用',
          '專心致志的學習態度',
          '積累的重要性'
        ],
        difficulty: 'intermediate',
        studyTime: 40
      },
      A3: {
        id: 'hkdse-a3-suxun-sixstates',
        title: '蘇洵《六國論》',
        author: '蘇洵',
        dynasty: '宋',
        category: '議論散文',
        mainTheme: '作者借六國被秦國所滅的史事，指出六國滅亡都是由於賄賂秦國。進而借古諷今，指出北宋的統治者不應該向外族實行屈辱求和的外交政策，否則只會重蹈六國滅亡的覆轍。',
        examFocus: {
          argumentationMethods: ['舉例論證', '比喻論證', '引用論證'],
          writingTechniques: ['借古諷今'],
          rhetoricalDevices: ['比喻', '對比', '設問', '對偶', '誇張']
        },
        keyPoints: [
          '六國滅亡的原因分析',
          '賄賂政策的危害',
          '借古諷今的寫作手法',
          '歷史教訓的現實意義'
        ],
        difficulty: 'advanced',
        studyTime: 50
      },
      A4: {
        id: 'hkdse-a4-zhuangzi-freedom',
        title: '莊子《逍遙遊》',
        author: '莊子',
        dynasty: '戰國',
        category: '議論散文',
        mainTheme: '以莊子與惠子的對話，說明不被世俗觀念束縛，轉換角度思考對於「用大」的重要性，以及指出「無用之用」的道理，藉此指出只有突破世俗思想的枷鎖，才能夠達到「逍遙」的境界。',
        examFocus: {
          argumentationMethods: ['對比論證', '舉例論證', '比喻論證'],
          writingTechniques: ['寓言說理', '對話體'],
          rhetoricalDevices: ['對比', '誇張', '反問']
        },
        keyPoints: [
          '逍遙的哲學境界',
          '無用之用的道理',
          '突破世俗觀念的重要性',
          '寓言說理的表達方式'
        ],
        difficulty: 'advanced',
        studyTime: 55
      },
      A5: {
        id: 'hkdse-a5-hanyu-teacher',
        title: '韓愈《師說》',
        author: '韓愈',
        dynasty: '唐',
        category: '議論散文',
        mainTheme: '文章的中心論點在於強調古代的學習者必定會有老師，強調從師學習的重要性。作者再文章中提出了老師的作用，並指出選擇老師的準則，從而批評當時世人恥於從師學習的陋習，並嘉許學生李蟠能夠勇於師從作者。',
        examFocus: {
          argumentationMethods: ['對比論證', '舉例論證', '引用論證'],
          writingTechniques: ['正反對比', '古今對比'],
          rhetoricalDevices: ['反問', '對偶', '頂真']
        },
        keyPoints: [
          '師者的作用和重要性',
          '選擇老師的標準',
          '批評恥於從師的陋習',
          '古今對比的論證效果'
        ],
        difficulty: 'intermediate',
        studyTime: 45
      }
    }
  },

  // B. 語錄體
  B: {
    category: '語錄體',
    description: '以對話形式記錄言論，體現思想精華',
    texts: {
      B1: {
        id: 'hkdse-b1-analects-ren',
        title: '《論語》論仁',
        author: '孔子及其弟子',
        dynasty: '春秋',
        category: '語錄體',
        mainTheme: '從個人修養以及待人處事兩方面，講述仁的內容，以及仁者對待仁的表現。',
        examFocus: {
          renContent: '克己復禮（克制自己，使自己的行為符合禮法）非禮勿視，非禮勿聽，非禮勿言，非禮勿動',
          renAttitude: '安於實行仁德，無論在任何時候都不會違背仁德。不會因為想要求得生存而違背仁德，會因為成全仁德而犧牲自己',
          rhetoricalDevices: ['排比', '對比', '對偶', '反問', '疊字']
        },
        keyPoints: [
          '仁的具體內容和表現',
          '克己復禮的修養要求',
          '仁者的品格特徵',
          '語錄體的表達特色'
        ],
        difficulty: 'intermediate',
        studyTime: 35
      },
      B2: {
        id: 'hkdse-b2-analects-filial',
        title: '《論語》論孝',
        author: '孔子及其弟子',
        dynasty: '春秋',
        category: '語錄體',
        mainTheme: '闡述了孝的本質，以及如何克盡孝道。',
        examFocus: {
          filialEssence: '無違（不要違背禮節）',
          filialPractice: '對待父母須心存敬重，子女在規勸父母時應該採取委婉的態度，要記住父母的年紀，及時盡孝',
          rhetoricalDevices: ['排比', '對比', '對偶', '反問', '疊字']
        },
        keyPoints: [
          '孝的本質和內涵',
          '實踐孝道的方法',
          '孝與禮的關係',
          '及時行孝的重要性'
        ],
        difficulty: 'beginner',
        studyTime: 30
      },
      B3: {
        id: 'hkdse-b3-analects-gentleman',
        title: '《論語》論君子',
        author: '孔子及其弟子',
        dynasty: '春秋',
        category: '語錄體',
        mainTheme: '從為學修身、處世待人、言行心境各方面，指出君子的特質和應有的行為態度，並指出君子與小人的區別。',
        examFocus: {
          gentlemanTraits: '不會感到憂慮和恐懼，不會成全他人的惡行，只會成全他人的善行，不會言過其實',
          gentlemanAttitude: '莊重、忠誠，講信用，會結交德行比自己優勝的人，勇於改錯，立身處世會以道義為根本',
          gentlemanVsVillain: '君子心胸光明磊落，小人常感到憂慮恐懼；君子不會成人之惡，小人會',
          rhetoricalDevices: ['排比', '對比', '對偶', '反問', '疊字']
        },
        keyPoints: [
          '君子的品格特質',
          '君子的行為準則',
          '君子與小人的對比',
          '修身養性的要求'
        ],
        difficulty: 'intermediate',
        studyTime: 40
      }
    }
  },

  // C. 人物傳記
  C: {
    category: '人物傳記',
    description: '記述人物生平事蹟，展現人物品格',
    texts: {
      C1: {
        id: 'hkdse-c1-simaqian-lianpo-linxiangru',
        title: '司馬遷《廉頗藺相如列傳》',
        author: '司馬遷',
        dynasty: '漢',
        category: '人物傳記',
        mainTheme: '透過「完璧歸趙」、「澠池之會」以及「負荊請罪」三個故事，凸顯藺相如機智勇敢，忠心愛國，以及忍辱負重、顧全大局的高尚情操，同時讚揚了廉頗勇於改過的美德。',
        examFocus: {
          storyDevelopment: '「完璧歸趙」→「澠池之會」→「負荊請罪」',
          characterPortrayal: ['語言描寫', '動作描寫', '神態描寫', '側面描寫'],
          rhetoricalDevices: ['對比']
        },
        keyPoints: [
          '三個故事的起承轉合',
          '人物性格的多面刻畫',
          '愛國主義精神的體現',
          '史傳文學的寫作特色'
        ],
        difficulty: 'advanced',
        studyTime: 60
      },
      C2: {
        id: 'hkdse-c2-mengzi-fish-desire',
        title: '孟子《魚我所欲也》',
        author: '孟子',
        dynasty: '戰國',
        category: '人物傳記',
        mainTheme: '同A2內容',
        examFocus: {
          argumentationMethods: ['比喻論證', '對比論證'],
          writingTechniques: ['正反立論'],
          rhetoricalDevices: ['比喻', '排比', '設問']
        },
        keyPoints: ['參考A1內容'],
        difficulty: 'intermediate',
        studyTime: 45
      },
      C3: {
        id: 'hkdse-c3-xunzi-learning-encouragement',
        title: '荀子《勸學》（節錄）',
        author: '荀子',
        dynasty: '戰國',
        category: '人物傳記',
        mainTheme: '同A2內容',
        examFocus: {
          argumentationMethods: ['比喻論證', '對比論證'],
          writingTechniques: ['層層遞進'],
          rhetoricalDevices: ['對比', '比喻', '排比', '對偶', '借代']
        },
        keyPoints: ['參考A2內容'],
        difficulty: 'intermediate',
        studyTime: 40
      },
      C4: {
        id: 'hkdse-c4-suxun-six-states-theory',
        title: '蘇洵《六國論》',
        author: '蘇洵',
        dynasty: '宋',
        category: '人物傳記',
        mainTheme: '同A3內容',
        examFocus: {
          argumentationMethods: ['舉例論證', '比喻論證', '引用論證'],
          writingTechniques: ['借古諷今'],
          rhetoricalDevices: ['比喻', '對比', '設問', '對偶', '誇張']
        },
        keyPoints: ['參考A3內容'],
        difficulty: 'advanced',
        studyTime: 50
      },
      C5: {
        id: 'hkdse-c5-zhuangzi-freedom-wandering',
        title: '莊子《逍遙遊》、韓愈《師說》',
        author: '莊子、韓愈',
        dynasty: '戰國、唐',
        category: '人物傳記',
        mainTheme: '參考A4、A5內容',
        examFocus: {
          argumentationMethods: ['對比論證', '舉例論證', '比喻論證'],
          writingTechniques: ['寓言說理', '對話體'],
          rhetoricalDevices: ['對比', '誇張', '反問']
        },
        keyPoints: ['參考A4、A5內容'],
        difficulty: 'advanced',
        studyTime: 60
      }
    }
  },

  // D. 抒情遊記
  D: {
    category: '抒情遊記',
    description: '記遊山水，借景抒情，表達情懷',
    texts: {
      D1: {
        id: 'hkdse-d1-fanzhongyan-yueyanglou-ji',
        title: '范仲淹《岳陽樓記》',
        author: '范仲淹',
        dynasty: '宋',
        category: '抒情遊記',
        mainTheme: '作者記述了重修岳陽樓一事，以及遷客騷人在陰雨天以及晴天見到洞庭湖不同的景色而產生不同的感情，抒發了自己希望仿效古代仁者不會因為外物的變化以及自身的際遇而感到悲傷或高興。抒發了自身「先天下之憂而憂，後天下之樂而樂」的抱負，並希望借此文勉勵同樣被貶的好友滕子京。',
        examFocus: {
          sceneryDescription: '洞庭湖陰雨天以及晴天的不同景物',
          emotionalExpression: '借景抒情的手法抒發遷客騷人的感情',
          contrastTechnique: '文章不同部分對比手法的應用',
          personalAspiration: '「先天下之憂而憂，後天下之樂而樂」的抱負',
          rhetoricalDevices: ['對偶', '擬人', '疊字', '借代']
        },
        keyPoints: [
          '借景抒情的寫作手法',
          '對比手法的運用',
          '憂樂觀的人生哲學',
          '古代仁者的理想人格'
        ],
        difficulty: 'advanced',
        studyTime: 55
      },
      D2: {
        id: 'hkdse-d2-liuzongyuan-xishan-yanyou-ji',
        title: '柳宗元《始得西山宴遊記》',
        author: '柳宗元',
        dynasty: '唐',
        category: '抒情遊記',
        mainTheme: '作者藉著記述發現以及遊歷西山的經過，抒發自己形體心神都得到解放，與天地萬物融合，拋卻寵辱的感受。並借西山的特立偏僻，暗示自己也有類似的遭遇，不與世俗為了利益汲汲營營的人為伍，表達自己孤高不凡的情操。',
        examFocus: {
          narrativeProcess: '發現西山→登上西山→在西山上飲酒→醉而進入醉鄉',
          sceneryObservation: '遠望、俯視以及仰望所見的景物',
          emotionalExpression: '借事以及景物抒發的感情'
        },
        keyPoints: [
          '遊記的敘事結構',
          '景物描寫的層次性',
          '託物言志的表達手法',
          '孤高不凡的人格追求'
        ],
        difficulty: 'advanced',
        studyTime: 50
      }
    }
  },

  // E. 議論抒情
  E: {
    category: '議論抒情',
    description: '議論中融入抒情，理情並茂',
    texts: {
      E1: {
        id: 'hkdse-e1-zhugeliang-chushibiao',
        title: '諸葛亮《出師表》',
        author: '諸葛亮',
        dynasty: '蜀漢',
        category: '議論抒情',
        mainTheme: '作者以分析當時天下以及蜀漢的情況為開端，解釋北伐的原因；並為後主提出治國方略，勸勉後主應該虛心納諫，處事公正，賞罰分明，親賢遠佞；再透過回憶自己與先帝的往事，表明自己對於蜀漢的忠心耿耿，強調自己對先帝以及後主的忠誠之心。',
        examFocus: {
          persuasionTechniques: '動之以情，曉之以理的遊說手法',
          situationAnalysis: '分析當時蜀漢與天下的形勢',
          personalLoyalty: '回憶與先帝的交往，強調忠心',
          governanceAdvice: '提出建議並指出後主施政上的缺失'
        },
        keyPoints: [
          '奏疏文體的特點',
          '情理並茂的表達方式',
          '忠君愛國的思想情感',
          '治國理政的智慧'
        ],
        difficulty: 'advanced',
        studyTime: 60
      }
    }
  },

  // F. 詩詞
  F: {
    category: '詩詞',
    description: '以詩詞形式抒發情感，展現文學之美',
    texts: {
      F1: {
        id: 'hkdse-f1-tangshi-sanzhou',
        title: '唐詩三首',
        author: '王維、李白、杜甫',
        dynasty: '唐',
        category: '詩詞',
        subTexts: {
          wangwei: {
            title: '王維《山居秋暝》',
            mainTheme: '借描寫秋天雨後山中傍晚的美景，凸顯了鄉居的人的淳樸生活，寄寓了作者對於寧靜的山裡隱居生活的嚮往，抒發自己願意寄情山水的高尚情操。'
          },
          libai: {
            title: '李白《月下獨酌》(其一)',
            mainTheme: '借記述自己在良辰美景之下獨自飲酒，唯有與影子與月亮作伴的情境，抒發了自己孤單落寞，鬱悶不快，缺少知己的心情，希望尋求解脫世俗的渴望。'
          },
          dufu: {
            title: '杜甫《登樓》',
            mainTheme: '借登樓見到繁花似錦的景色，引發了作者即使看著如此美景，也依然因為國家殘破而感到無盡的傷痛。一方面慨嘆君主寵信小人，另一方面也慨嘆自己空有報國之心卻不能夠為時所用的無奈心情，再抒發了自身憂國憂民的愛國情懷。'
          }
        },
        examFocus: {
          poetryForm: '詩歌與詞的體例',
          emotionalExpression: '作者借詩或詞抒發的感情',
          imagery: '作者在文本中描寫的事物或者景色'
        },
        keyPoints: [
          '唐詩的藝術特色',
          '不同詩人的風格特點',
          '借景抒情的表達手法',
          '詩歌的意境營造'
        ],
        difficulty: 'intermediate',
        studyTime: 50
      },
      F2: {
        id: 'hkdse-f2-ci-sanzhou',
        title: '詞三首',
        author: '蘇軾、李清照、辛棄疾',
        dynasty: '宋',
        category: '詩詞',
        subTexts: {
          sushi: {
            title: '蘇軾《念奴嬌．赤壁懷古》',
            mainTheme: '借描述赤壁雄奇壯觀的景色，引發了對周瑜的懷念，從而抒發自己年華老去，卻未能如周瑜般建功立業的無奈之情，最終只能夠對著江月喝酒，排遣心情。'
          },
          liqingzhao: {
            title: '李清照《聲聲慢．秋情》',
            mainTheme: '借描述秋天殘破憔悴的景物，渲染出一種淒清的氛圍，抒發作者懷念故人，故鄉的秋思，以及國破家亡，年華老去等複雜的哀思。'
          },
          xinqiji: {
            title: '辛棄疾《青玉案．元夕》',
            mainTheme: '借描寫元宵時張燈結綵的盛況，諷刺當時南宋統治者耽於享樂，苟且偷安的治國策略。並且以那位在燈火零落處的「那人」自比，凸顯自己不與世俗同流合污的高尚情操。'
          }
        },
        examFocus: {
          poetryForm: '詩歌與詞的體例',
          emotionalExpression: '作者借詩或詞抒發的感情',
          imagery: '作者在文本中描寫的事物或者景色'
        },
        keyPoints: [
          '宋詞的藝術特色',
          '詞人的不同風格',
          '懷古詠史的主題',
          '詞的意境與情感'
        ],
        difficulty: 'advanced',
        studyTime: 55
      }
    }
  }
};

// 學習活動類型配置
export const studyActivityTypes = {
  quiz: {
    name: '測驗',
    icon: '🎯',
    description: '多選題測驗，檢測理解程度',
    color: 'bg-green-100 text-green-800'
  },
  flashCards: {
    name: '學習卡片',
    icon: '🧠',
    description: '重點知識卡片，加深記憶',
    color: 'bg-purple-100 text-purple-800'
  },
  notes: {
    name: '學習筆記',
    icon: '📝',
    description: '重點整理，系統學習',
    color: 'bg-blue-100 text-blue-800'
  },
  practice: {
    name: '練習題',
    icon: '✍️',
    description: '模擬試題，實戰演練',
    color: 'bg-orange-100 text-orange-800'
  },
  analysis: {
    name: '文本分析',
    icon: '🔍',
    description: '深度解析，理解內涵',
    color: 'bg-indigo-100 text-indigo-800'
  },
  comparison: {
    name: '比較研究',
    icon: '⚖️',
    description: '對比分析，掌握特色',
    color: 'bg-yellow-100 text-yellow-800'
  }
};

// 難度等級配置
export const difficultyLevels = {
  beginner: {
    name: '初級',
    color: 'bg-green-100 text-green-800',
    description: '基礎概念，適合初學者'
  },
  intermediate: {
    name: '中級',
    color: 'bg-yellow-100 text-yellow-800',
    description: '進階內容，需要一定基礎'
  },
  advanced: {
    name: '高級',
    color: 'bg-red-100 text-red-800',
    description: '深度分析，適合進階學習'
  }
};

// 獲取所有文本列表
export const getAllTexts = () => {
  const allTexts = [];
  Object.keys(hkdseTexts).forEach(categoryKey => {
    const category = hkdseTexts[categoryKey];
    Object.keys(category.texts).forEach(textKey => {
      allTexts.push({
        ...category.texts[textKey],
        categoryKey,
        textKey,
        categoryName: category.category
      });
    });
  });
  return allTexts;
};

// 根據類別獲取文本
export const getTextsByCategory = (categoryKey) => {
  return hkdseTexts[categoryKey] || null;
};

// 根據ID獲取特定文本
export const getTextById = (textId) => {
  const allTexts = getAllTexts();
  return allTexts.find(text => text.id === textId);
};

// 獲取統計數據
export const getHKDSEStats = () => {
  const allTexts = getAllTexts();
  return {
    totalTexts: allTexts.length,
    totalCategories: Object.keys(hkdseTexts).length,
    totalStudyTime: allTexts.reduce((sum, text) => sum + text.studyTime, 0),
    difficultyDistribution: {
      beginner: allTexts.filter(text => text.difficulty === 'beginner').length,
      intermediate: allTexts.filter(text => text.difficulty === 'intermediate').length,
      advanced: allTexts.filter(text => text.difficulty === 'advanced').length
    },
    categoryDistribution: Object.keys(hkdseTexts).reduce((acc, key) => {
      acc[key] = Object.keys(hkdseTexts[key].texts).length;
      return acc;
    }, {})
  };
}; 